import { combineReducers, createAction, createSlice } from "@reduxjs/toolkit";
import { createEvent } from "effector";
import { Post } from "./types";
import { SaveFormResult } from "../../components/Posts/PostForm/types";

export const closePostForm = createAction<SaveFormResult | undefined>(
  "closePostForm"
);

export const isFormSubmitting = createSlice({
  name: "isFormSubmitting",
  initialState: false,
  reducers: {
    startFormSubmitting: () => true,
    finishFormSubmitting: () => false,
  },
});

export const formReducer = combineReducers({
  isSubmitting: isFormSubmitting.reducer,
});

export const postsCreatedOrUpdated = createEvent<{
  post: { newPosts: Post[] };
}>();
